import api from 'apis/config/api-service';
import { toCmsListQuery } from 'apis/config/legacy-table-query';

interface Country {
  id?: string | number;
  [key: string]: any;
}

interface CountryParams {
  [key: string]: any;
}

const cmsCountries = 'api/v1/cms/countries';

export default {
  getCountries: (params?: CountryParams) => api.get(cmsCountries, { params: toCmsListQuery(params) }),
  getCountryById: (id: string | number) => api.get(`${cmsCountries}/${id}`),
  // A PATCH without lat/long (the list's active toggle) keeps the stored location; the code cannot change.
  addOrUpdateCountry: (data: Country) =>
    data.id ? api.patch(`${cmsCountries}/${data.id}`, data) : api.post(cmsCountries, data),
};
